/* eslint-disable @typescript-eslint/no-unused-vars */
import { InjectionToken, ValueProvider } from '@angular/core';
import { IFilter } from '@aston/foundation';
import { Observable, of } from 'rxjs';

export interface UserFiltersConnector {
	selectFiltersIsLoading: () => Observable<boolean>;
	selectFiltersError: () => Observable<string | null>;
	selectFiltersByDomain: (domain: string) => Observable<IFilter[][]>;
	selectCanSaveFilterForDomain: (domain: string) => Observable<boolean>;
	addFiltersToDomain: (domain: string, filters: IFilter[]) => void;
	removeFiltersFromDomain: (domain: string, filters: IFilter[], index?: number) => void;
}

const missingConnector = 'no UserFiltersConnector provided, did you forget to provide USER_FILTERS_CONNECTOR ?'; 
export const USER_FILTERS_CONNECTOR = new InjectionToken<UserFiltersConnector>('USER_FILTERS_CONNECTOR', {
	providedIn: 'root',
	factory: () => ({
		selectFiltersIsLoading: () => { throw missingConnector },
		selectFiltersError: () => { throw missingConnector },
		currentPreferences: of({}),
		selectFiltersByDomain: (domain: string) => { throw missingConnector },
		selectCanSaveFilterForDomain: (domain: string) => { throw missingConnector },
		addFiltersToDomain: (domain: string, filters: IFilter[]) => { throw missingConnector },
		removeFiltersFromDomain: (domain: string, filters: IFilter[], index?: number) => { throw missingConnector },
	})
});

export const provideMockUserFiltersConnector = (): ValueProvider => (
	{ provide: USER_FILTERS_CONNECTOR,
		useValue: {
			selectFiltersIsLoading: () => of(false),
			selectFiltersError: () => of(null),
			currentPreferences: of({}),
			updatePreferences: () => of(null),
			selectFiltersByDomain: (domain: string) => of([]),
			selectCanSaveFilterForDomain: (domain: string) => of(true),
			addFiltersToDomain: (domain: string, filters: IFilter[]) => ({}),
			removeFiltersFromDomain: (domain: string, filters: IFilter[], index?: number) => ({}),
		}
	})
